// Recovered compiled webpack factory 10883. Edit this function expression; run npm run build.
(t, e, i) => {
  function n(t) {
    let e = [{}, {}];
    return (
      t?.values.forEach((t, i) => {
        ((e[0][i] = t.get()), (e[1][i] = t.getVelocity()));
      }),
      e
    );
  }
  function s(t, e, i, s) {
    if ("function" == typeof e) {
      let [r, o] = n(s);
      e = e(void 0 !== i ? i : t.custom, r, o);
    }
    if (("string" == typeof e && (e = t.variants && t.variants[e]), "function" == typeof e)) {
      let [r, o] = n(s);
      e = e(void 0 !== i ? i : t.custom, r, o);
    }
    return e;
  }
  i.d(e, { a: () => s });
}
